import LoadingWheel from "../shared/LoadingWheel";
import { IAccount } from "../../models/account/IAccount";
import useAccountLeads from "../../data/useAccountLeads";
import { ILead, LeadSource, LeadStatus } from "../../models/Lead";
import PriceFormat from "../../utils/priceFormat";
import date from "date-and-time";
import openInNewTab from "../../utils/openInNewTab";

interface AccountLeadsListRowProps {
  lead: ILead;
  onClick: (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => void;
}

function AccountLeadsListRow({ lead, onClick }: AccountLeadsListRowProps) {
  return (
    <tr onClick={onClick} className="hover:cursor-pointer hover:bg-gray-100">
      <td className="px-3 py-3 border hidden lg:table-cell text-sm">
        {LeadSource[lead.website]}
      </td>
      <td className="px-3 py-3 border lg:table-cell text-sm">
        {lead.vehicle?.vrm}
      </td>
      <td className="px-3 py-3 border hidden lg:table-cell text-sm">
        {lead.vehicle?.combinedMake} {lead.vehicle?.combinedModel}  
      </td>
      <td className="px-3 py-3 border lg:table-cell text-sm">
        {LeadStatus[lead.status]}
      </td>
      <td className="px-3 py-3 border hidden lg:table-cell text-sm">
        {PriceFormat(lead.priceWithVAT)} {lead.applyVAT ? " (incl. VAT)" : ""}
      </td>
      <td className="px-3 py-3 border hidden lg:table-cell text-sm">
        {lead.paymentConfirmedOn ? date.format(new Date(lead.paymentConfirmedOn), "DD/MM/YYYY") : "N/A"}
      </td>
      <td className="px-3 py-3 border hidden lg:table-cell text-sm">
        {lead.vehicle?.codRequired ? "Yes" : "No"}
      </td>
      <td className="px-3 py-3 border hidden lg:table-cell text-sm">
        {lead.vehicle?.codCertificateNumber || "N/A"}
      </td>
    </tr>
  );
}

export default function AccountLeadsList({ account }: { account: IAccount }) {
  const { accountLeads } = useAccountLeads(account.id, "AccountLeadsList");

  if (accountLeads.isLoading) {
    return (
      <div className="flex items-center justify-center py-10">
        <LoadingWheel />
      </div>
    );
  } else if (
    accountLeads.isError ||
    !accountLeads.data ||
    !accountLeads.data.data
  ) {
    return (
      <div className="flex items-center justify-center py-10">
        <p className="text-red-600 font-bold text-xl">Error loading leads</p>
      </div>
    );
  } else {
    return (
      <>
        <div>
          <div className="sm:hidden p-2">
            <p className="text-center">Tap a row to see the full record</p>
          </div>
          <table className="min-w-full divide-y border-t border-collapse divide-gray-300">
            <thead>
              <tr className="bg-primary-50 text-gray-800">
                <th className="py-3.5 px-3 text-sm font-semibold hidden lg:table-cell text-left">
                  Source
                </th>
                <th className="py-3.5 px-3 text-sm font-semibold lg:table-cell text-left">
                  VRM
                </th>
                <th className="py-3.5 px-3 text-sm font-semibold hidden lg:table-cell text-left">
                  Make & Model
                </th>
                <th className="py-3.5 px-3 text-sm font-semibold lg:table-cell text-left">
                  Status
                </th>
                <th className="py-3.5 px-3 text-sm font-semibold hidden lg:table-cell text-left">
                  Price
                </th>
                <th className="py-3.5 px-3 text-sm font-semibold hidden lg:table-cell text-left">
                  Payment Date
                </th>
                <th className="py-3.5 px-3 text-sm font-semibold hidden lg:table-cell text-left">
                  COD Required
                </th>
                <th className="py-3.5 px-3 text-sm font-semibold hidden lg:table-cell text-left">
                  COD Number
                </th>
              </tr>
            </thead>
            <tbody>
              {accountLeads.data.data.map((lead) => (
                <AccountLeadsListRow
                  key={lead.id}
                  lead={lead}
                  onClick={() => openInNewTab(`/leads/${lead.id}`)} // Open lead in new tab
                />
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  }
}
